import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from "@angular/core";
import {debounceTime, Subject, Subscription} from "rxjs";

@Component({
    selector: "wbo-spinner-control",
    templateUrl: "./spinner-control.component.html",
    styleUrls: ["./spinner-control.component.scss"]
})
export class SpinnerControlComponent implements OnInit, OnDestroy {
    @Input() public label: string;
    @Input() public readonly: boolean = false;
    @Input() public loading: boolean = false;
    @Input() public increment: number = 1;
    @Input() public debounce: number = 1000;
    @Input() public placeholder: string;
    @Input() public notation: string;

    @Output() public valueChangeStarted: EventEmitter<number> = new EventEmitter<number>();
    @Output() public valueChange: EventEmitter<number> = new EventEmitter<number>();

    currentValue: number;

    private _value: number;
    private subscriptions: Subscription = new Subscription();
    private updateValueSubject: Subject<number> = new Subject<number>()

    constructor() {
    }

    ngOnInit(): void {
        this.subscriptions.add(this.updateValueSubject.pipe(
            debounceTime(this.debounce)
        ).subscribe(async (value: number) => {
            this._value = this.currentValue;
            this.valueChange.next(this.value);
        }));
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    @Input() get value(): number {
        return this._value;
    }

    set value(value: number) {
        if (value !== this._value || this.currentValue !== this._value) {
            this.currentValue = value;
            this._value = value;
        }
    }

    updateValue(increment: number): void {
        this.currentValue = this.currentValue || 0;
        this.currentValue = this.currentValue - (this.currentValue % this.increment)
        this.currentValue = Math.max(this.currentValue + increment, 0);
        if (this.currentValue === 0) {
            this.currentValue = undefined;
        }
        this.valueChangeStarted.next(this.currentValue);
        this.updateValueSubject.next(this.currentValue);
    }

    clearValue(): void {
        this.currentValue = undefined;
        this.valueChangeStarted.next(this.currentValue);
        this.updateValueSubject.next(this.currentValue);
    }
}
